export const LIVE_PROJECT_CHASER_DEFAULTS = {
    amber_after_days: 40,
    red_after_days: 60
};

export const USER_PREFERENCES_CACHE_KEY = 'monsurv_user_preferences_v1';
export const USER_PREFERENCES_UPDATED_EVENT = 'monsurv:user-preferences-updated';

export function normalizeLiveProjectChaserThresholds(value) {
    const source = value && typeof value === 'object' ? value : {};
    const amberRaw = Number(source.amber_after_days);
    const amberAfterDays = Number.isFinite(amberRaw)
        ? Math.max(0, Math.min(3649, Math.trunc(amberRaw)))
        : LIVE_PROJECT_CHASER_DEFAULTS.amber_after_days;
    const redRaw = Number(source.red_after_days);
    const redAfterDays = Number.isFinite(redRaw)
        ? Math.max(amberAfterDays + 1, Math.min(3650, Math.trunc(redRaw)))
        : Math.max(amberAfterDays + 1, LIVE_PROJECT_CHASER_DEFAULTS.red_after_days);

    return {
        amber_after_days: amberAfterDays,
        red_after_days: redAfterDays
    };
}

export function getLiveProjectChaserThresholds(preferences) {
    return normalizeLiveProjectChaserThresholds(preferences?.actions?.live_project_chaser);
}

export function readLiveProjectChaserThresholds() {
    try {
        const raw = localStorage.getItem(USER_PREFERENCES_CACHE_KEY);
        return getLiveProjectChaserThresholds(raw ? JSON.parse(raw) : null);
    } catch {
        return { ...LIVE_PROJECT_CHASER_DEFAULTS };
    }
}

export function getLiveProjectChaserTone(days, thresholds) {
    if (!Number.isFinite(days)) return 'unknown';
    const normalized = normalizeLiveProjectChaserThresholds(thresholds);
    if (days > normalized.red_after_days) return 'red';
    if (days > normalized.amber_after_days) return 'amber';
    return 'green';
}
